import { useState } from 'react';
import { Link } from 'react-router-dom';
import Button from '@/components/ui/Button';
import ParchmentCard from '@/components/ui/ParchmentCard';
import useAuth from '@/hooks/useAuth';

export default function LoginPage() {
  const { handleLogin } = useAuth();
  const [form, setForm] = useState({ username: '', password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setLoading(true);
    try {
      await handleLogin(form.username, form.password);
    } catch (err) {
      setError(err.response?.data?.message || 'Não foi possível entrar.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <main className="grid h-full place-items-center overflow-y-auto bg-background px-4 py-4">
      <ParchmentCard className="w-full max-w-sm">
        <div className="mb-2 flex items-center justify-between gap-3">
          <Link className="text-sm font-bold text-accent hover:text-accent" to="/">
            ← Início
          </Link>
          <picture>
            <source srcSet="/branding/logo-hakkencity.webp" type="image/webp" />
            <img src="/branding/logo-hakkencity-opt.png" alt="Hakken City" className="h-24 w-auto object-contain sm:h-28" />
          </picture>
          <span className="w-12" />
        </div>
        <h1 className="font-urban text-2xl font-black text-fg">Entrar</h1>
        <form className="mt-5 grid gap-3" onSubmit={submit}>
          <input className="rounded-xl border-2 border-edge bg-surfaceAlt px-4 py-3 text-fg outline-none focus:border-accent" placeholder="Username" value={form.username} onChange={(e) => setForm({ ...form, username: e.target.value })} />
          <input className="rounded-xl border-2 border-edge bg-surfaceAlt px-4 py-3 text-fg outline-none focus:border-accent" placeholder="Password" type="password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
          {error && <p className="text-sm font-bold text-pirate-red">{error}</p>}
          <Button type="submit" fullWidth variant="gold" disabled={loading}>{loading ? 'A entrar...' : 'Entrar'}</Button>
        </form>
        <Link className="mt-4 block text-center text-sm font-bold text-accent" to="/register">Criar nova conta</Link>
      </ParchmentCard>
    </main>
  );
}
